import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Instagram, Twitter, Youtube } from "lucide-react";

export const Footer = () => {
    const [email, setEmail] = useState("");
    const [msg, setMsg] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (!email) return;
        setLoading(true);
        try {
            await api.post("/newsletter", { email });
            setMsg("Welcome to the circle.");
            setEmail("");
        } catch {
            setMsg("Please enter a valid email.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <footer data-testid="site-footer" className="bg-[#0A0A0A] text-white">
            <div className="px-6 md:px-12 lg:px-20 py-20 md:py-28 grid md:grid-cols-12 gap-12">
                <div className="md:col-span-5">
                    <div className="eyebrow text-[#D4AF37] mb-6">Newsletter</div>
                    <h3 className="font-serif text-3xl md:text-4xl leading-tight mb-6">
                        Letters of kindness, <br />delivered slowly.
                    </h3>
                    <p className="text-white/60 mb-8 max-w-md font-light">
                        Monthly notes from the studio — new episodes, guest reflections, and small acts that moved us.
                    </p>
                    <form onSubmit={submit} className="flex border-b border-white/30 pb-2 max-w-md">
                        <input
                            data-testid="newsletter-email-input"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="your@email.com"
                            className="flex-1 bg-transparent outline-none text-white placeholder:text-white/40 py-2"
                        />
                        <button
                            data-testid="newsletter-submit"
                            type="submit"
                            disabled={loading}
                            className="eyebrow text-[#D4AF37] hover:text-white transition-colors"
                        >
                            {loading ? "..." : "Subscribe →"}
                        </button>
                    </form>
                    {msg && <p data-testid="newsletter-message" className="text-[#D4AF37] text-sm mt-3">{msg}</p>}
                </div>

                <div className="md:col-span-3">
                    <div className="eyebrow text-white/60 mb-5">Listen</div>
                    <ul className="space-y-3 font-light">
                        <li><Link to="/episodes" className="hover:text-[#D4AF37]">All Episodes</Link></li>
                        <li><Link to="/guests" className="hover:text-[#D4AF37]">Guests</Link></li>
                        <li><a href="https://open.spotify.com" target="_blank" rel="noreferrer" className="hover:text-[#D4AF37]">Spotify</a></li>
                        <li><a href="https://podcasts.apple.com" target="_blank" rel="noreferrer" className="hover:text-[#D4AF37]">Apple Podcasts</a></li>
                    </ul>
                </div>

                <div className="md:col-span-2">
                    <div className="eyebrow text-white/60 mb-5">Studio</div>
                    <ul className="space-y-3 font-light">
                        <li><Link to="/about" className="hover:text-[#D4AF37]">About</Link></li>
                        <li><Link to="/apply" className="hover:text-[#D4AF37]">Be a Guest</Link></li>
                        <li><Link to="/shop" className="hover:text-[#D4AF37]">Shop</Link></li>
                    </ul>
                </div>

                <div className="md:col-span-2">
                    <div className="eyebrow text-white/60 mb-5">Follow</div>
                    <div className="flex gap-4">
                        <a href="#" className="hover:text-[#D4AF37]"><Instagram size={20} strokeWidth={1.5} /></a>
                        <a href="#" className="hover:text-[#D4AF37]"><Twitter size={20} strokeWidth={1.5} /></a>
                        <a href="#" className="hover:text-[#D4AF37]"><Youtube size={20} strokeWidth={1.5} /></a>
                    </div>
                </div>
            </div>

            <div className="border-t border-white/10 px-6 md:px-12 lg:px-20 py-8 flex flex-col md:flex-row justify-between items-center gap-4">
                <div className="flex items-center gap-4">
                    <img
                        src="https://customer-assets.emergentagent.com/job_podcast-merch-hub/artifacts/9rqltbjo_Transparentgoklogo.png"
                        alt="The Gift of Kindness Podcast"
                        className="h-20 w-auto opacity-95"
                        draggable="false"
                    />
                    <span className="text-white/60 font-sans text-sm">© {new Date().getFullYear()}</span>
                </div>
                <Link to="/admin/login" data-testid="footer-admin-link" className="eyebrow text-white/40 hover:text-[#D4AF37]">Admin</Link>
            </div>
        </footer>
    );
};
